/* Represents all the client messages and thread types in WP3 */
export const MessagePriorities = {
    Low: 10,
    Medium: 20,
    High: 30
};


export type BaseMessageType = {
    threadId?: string | null | undefined;
    recipients: string[];
    text?: string | null | undefined;
};

export type GridMessageType = {
    messageId: string
    threadId: string
    subject?: string | null
    messageCategory?: number | null
    messageType?: number | null
    sentStatus: number
    senderId?: string | null
    senderType?: number | null
    senderName?: string | null
    message: string
    statusText: string
    sentOnDate?: string | null
    masterAccountId?: string | null
    masterAccountName?: string | null
    reportId?: string | null
    reportDocumentId?: string | null  
    projectId?: string | null
    project?: string | null
    doneById?: string | null
    doneByName?: string | null
    doneDate?: string | null
    isDone: boolean
    userNoFurtherActionTime?: string | null
    userReadTime?: string | null
    messagePriority: number
    userMessagePriority?: number | null
    isActionRequired: boolean
    deadlineDate?: string | null
    userReminderDate?: string | null
    recipientIds: string[]
    recipientNames: string[]
    attachments: any[]
};

export type GridMessageFilters = {
    direction?: number
    showDone: boolean
    showHiddenByUser: boolean
    masterAccountId?: string | null
    sentDateFrom?: string | null
    sentDateTo?: string | null
    deadlineDateFrom?: string | null
    deadlineDateTo?: string | null
    reminderDateFrom?: string | null
    reminderDateTo?: string | null
    senderId?: string | null
    recipientId?: string | null
    subject?: string | null
    type?: number | null
    category?: number | null
    priorities?: number[] | null
    userPriorities?: number[] | null
};